export default __webpack_public_path__ + "static/media/000_intro_part2.6854bc11.mp4";